import React from "react";

export const ReloadingIcon = () => (
    <i className="icon ion-ios7-reloading" />
);
